'use client';

import type { ReactNode } from 'react';
import { cn } from '@/app/utils';
import { usePointerTracking } from '../../../_hooks/use-pointer-tracking';
import './styles.css';

/**
 * GlowingCard Props
 */
interface GlowingCardProps {
  /** 子元素 */
  children: ReactNode;
  /** 自定义类名 */
  className?: string;
  /** 内容区域类名 */
  innerClassName?: string;
  /** 发光灵敏度（0-100），值越小越容易触发发光 */
  glowSensitivity?: number;
}

/**
 * 发光边框卡片组件
 * 鼠标移动时会在边缘产生彩色发光效果
 */
export function GlowingCard({ children, className, innerClassName, glowSensitivity = 30 }: GlowingCardProps) {
  const { ref, cssVariables, isAnimating } = usePointerTracking({
    glowSensitivity,
  });

  return (
    <div ref={ref} className={cn('glowing-card', isAnimating && 'animating', className)} style={cssVariables}>
      <span className="glowing-card__glow" />
      <div className={cn('glowing-card__inner', innerClassName)}>{children}</div>
    </div>
  );
}
